<template>
  <div
    v-if="visible"
    :class="['toast', 'fade-in', type]"
    :style="getBorderStyle()"
  >
    <div class="toast-content">
      <div class="text-center p-3 toast-style">
        <div class="text-center">
          <i :class="[icon, 'fs-4', 'p-1', `${type}-style`]"></i>
        </div>
      </div>
      <div class="mx-3 toast-message">
        <strong>{{ message }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      type: "error",
      timeout: null,
      icon: "ri-check-line",
    };
  },
  methods: {
    showToast(message, type, duration = 3000) {
      this.message = message;
      this.icon = this.getIcon(type);
      this.type = type;
      this.visible = true;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.visible = false;
      }, duration);
    },

    getIcon(type) {
      const icons = {
        success: "ri-check-line",
        error: "ri-close-circle-line",
        warning: "ri-alert-line",
        info: "ri-information-line",
      };
      return icons[type] || "ri-information-line";
    },
    getBorderStyle() {
      const colors = {
        success: "green",
        error: "red",
        warning: "#ffcc00",
        info: "#007bff",
      };
      return { borderLeft: `8px solid ${colors[this.type] || "black"}` };
    },
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 120px;
  right: 20px;
  min-width: 250px;
  font-size: 14px;
  padding: 4px;
  background-color: white;
  z-index: 1000;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.success-style {
  color: green;
  border: 2px solid green;
  border-radius: 14px;
}
.error-style {
  color: red;
  border: 2px solid red;
  border-radius: 14px;
}
.warning-style {
  color: #ffcc00;
  border: 2px solid #ffcc00;
  border-radius: 14px;
}
.info-style {
  color: #007bff;
  border: 2px solid #007bff;
  border-radius: 14px;
}

.toast-content {
  display: flex;
  align-items: center;
}

.toast-message {
  font-size: 13px;
  text-transform: capitalize;
  color: rgb(25, 22, 22);
}

.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
